// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3WGYi","title":"AfterFrontImage_title__23Ma_"};